/* angular:styles/component:css;1d9a5060e0ea17811b0c6c32507e6a0cae376711ca03d1ed141739ab975a40f6;/src/src/app/edge/live/Controller/Io/Braiins/pages/mode/mode.ts */
::ng-deep formly-form {
  height: 100% !important;
}
/*# sourceMappingURL=mode.css.map */
